module.exports = __webpack_public_path__ + "media/images/symbols/instagram-431703230a71794665f4f738305882de.svg";